import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ items = [], onNavy = false }) {
  const base = onNavy ? "text-[#9aa0b0]" : "text-[#85827D]";
  const active = onNavy ? "text-[#D8BE87]" : "text-[#1E2A44]";
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs">
      <ol className="flex items-center flex-wrap gap-1.5 text-xs">
        {items.map((it, i) => {
          const last = i === items.length - 1;
          return (
            <li key={i} className="flex items-center gap-1.5">
              {last || !it.path ? (
                <span className={`${active} uppercase tracking-[0.14em]`} aria-current="page">
                  {it.name}
                </span>
              ) : (
                <Link to={it.path} className={`${base} uppercase tracking-[0.14em] hover:${active} transition-colors`}>
                  {it.name}
                </Link>
              )}
              {!last && <ChevronRight size={12} className={base} />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
